import { render, staticRenderFns } from "./boruta_chart.vue?vue&type=template&id=3ed059b5&"
import script from "./boruta_chart.vue?vue&type=script&lang=js&"
export * from "./boruta_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports